import React from "react";
import styles from "../ProductTagComp/ProductTagComp.module.scss";


export default function ProductTagComp(props) {
  {
    if(props.cvalue) {
      return (
        <>
          <div className={`${styles.product_badge} ${props.cname}`}>{props.cvalue}</div>
        </>
      );
    }
  }
}
